


































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import dialogNewBoleto from '@/components/dialogNewBoleto.vue'
import DialogNewDescuentoBoleto from '@/components/dialogNewDescuentoBoleto.vue'
import { HTTP } from '@/plugins/axios'
import { BoletoDTO } from '@/interfaces/Boleto.interface'
import { UserTextMsg } from '@/interfaces/Usuarios.interface'
import { BoletoDescuentoDTO } from '@/interfaces/DialogNewDescuentoBoleto.interface'
import { EventoDTO } from '@/interfaces/Evento.interface'
import ErrorMixin from '@/mixins/Error'

@Component ({
  components: {
    dialogNewBoleto,
    DialogNewDescuentoBoleto
  },
  mixins: [
    ErrorMixin
  ]
})
export default class ViewBoletos extends Vue {
  private name: string = 'ViewBoletos'
  private tab: number = 1
  private infoBoleto: object = {}
  private actionBoleto: string = 'new'
  private updateBoletoTable: boolean = false
  private infoDescuento: object = {}
  private actionDescuento: string = 'new'
  private updateDescuentoTable: boolean = false
  private headersDescuentos: any[] = [
    {
      text: 'Nombre',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Categoria Boleto', value: 'descType' },
    { text: 'Descuento', value: 'descValue' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private headers: any[] = [
    {
      text: 'Nombre',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Rango Inicial', value: 'folioBeg' },
    { text: 'Rango Final', value: 'folioEnd' },
    { text: 'Total', value: 'total' },
    { text: 'Costo', value: 'cost' },
    { text: 'Acciones', value: 'acciones' }
    ]
  private tableBoletos: BoletoDTO[] = []
  private tableDescuentos: BoletoDescuentoDTO[] = []
  private textMSG: UserTextMsg = {
    deleteDescuento: {
      success: {
        text: 'Eliminado Rol:',
        color: 'success'
      },
      fail: {
        text: 'Error al eliminar Rol:',
        color: 'error'
      },
    },
    deleteBoleto: {
      success: {
        text: 'Eliminado Usuario:',
        color: 'success'
      },
      fail: {
        text: 'Error al eliminar usuario:',
        color: 'error'
      },
    },
    blockBoleto: {
      success: {
        text: 'Usuario Bloqueado:',
        color: 'success'
      },
      fail: {
        text: 'Error al bloquear usuario:',
        color: 'error'
      },
    },
    UnBlockBoleto: {
      success: {
        text: 'Usuario Des-Bloqueado:',
        color: 'success'
      },
      fail: {
        text: 'Error al Des-bloquear Usuario:',
        color: 'error'
      },
    }
  }
  private eventoInfo: EventoDTO = null

  @Watch('updateBoletoTable')
  private watchUpdateBoletoTable (v: boolean) {
    console.log('watchUpdateBoletoTable :: ', v)
    if (v) {
      this.gShowAllBoletos()
      this.updateBoletoTable = false
    }
  }
  @Watch('updateDescuentoTable')
  private watchUpdateDescuentoTable (v: boolean) {
    console.log('watchUpdateDescuentoTable :: ', v)
    if (v) {
      this.gShowAllDescuentos()
      this.updateDescuentoTable = false
    }
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gShowAllBoletos ()
    this.gShowAllDescuentos ()
  }

  private editBoleto (item: BoletoDTO) {
    this.infoBoleto = Object.assign({}, item)
    this.actionBoleto = 'edit'
  }

  private editDescuento (item: any) {
    this.infoDescuento = Object.assign({}, item)
    this.actionDescuento = 'edit'
  }

  private BlockDescuento (item: BoletoDescuentoDTO) {
    console.log('BlockDescuento :: ', item)
    let status = 'block'
    let snackbarMSG = this.textMSG.blockBoleto
    if (item.status) {
      status = 'unblock'
      snackbarMSG = this.textMSG.UnBlockBoleto
    }

    HTTP.get('descuento/' + item.id + '/' + status)
      .then((response) => {
        console.log('BlockDescuento :: response :: ', response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: snackbarMSG.success.text + ' ' + item.name,
          color: snackbarMSG.success.color,
          show: true,
          timeout: 2000
        })
        this.gShowAllDescuentos ()
      })
      .catch((e) => {
        console.log('BlockDescuento :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: snackbarMSG.fail.text + ' ' + item.name,
          color: snackbarMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private BlockBoleto (item: BoletoDTO) {
    console.log('UpdateUsuario :: ', item)
    let status = 'block'
    let snackbarMSG = this.textMSG.blockBoleto
    if (item.status) {
      status = 'unblock'
      snackbarMSG = this.textMSG.UnBlockBoleto
    }

    HTTP.get('boleto/' + item.id + '/' + status)
      .then((response) => {
        console.log('BlockBoleto :: response :: ', response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: snackbarMSG.success.text + ' ' + item.name,
          color: snackbarMSG.success.color,
          show: true,
          timeout: 2000
        })
        this.gShowAllBoletos ()
      })
      .catch((e) => {
        console.log('BlockBoleto :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: snackbarMSG.fail.text + ' ' + item.name,
          color: snackbarMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private gShowAllBoletos () {
    console.log('gShowAllRol :: ')
    HTTP.get('boleto/')
      .then((response) => {
        console.log('gShowAllRol :: response :: ', response.data)
        this.tableBoletos = response.data
      })
      .catch((e) => {
        console.log('gShowAllRol :: catch :: ', e.response.data)
      })
  }
  private gShowAllDescuentos () {
    console.log('gShowAllDescuentos :: ')
    HTTP.get('descuento/')
      .then((response) => {
        console.log('gShowAllDescuentos :: response :: ', response.data)
        this.tableDescuentos = response.data
      })
      .catch((e) => {
        console.log('gShowAllDescuentos :: catch :: ', e.response.data)
      })
  }

  private sOrder (item: number, order: string) {
    console.log('gSetOrder :: ')
    HTTP.get('boleto/' + item + '/order/' + order)
      .then((response) => {
        console.log('gShowAllDescuentos :: response :: ', response.data)
        if (response.data.success) {
          this.gShowAllBoletos()
        }
      })
      .catch((e) => {
        console.log('gShowAllDescuentos :: catch :: ', e.response.data)
      })
  }
}
